import React from "react";
import {useSelector} from "react-redux";

import Box from "../../Interface/Box";
import Separator from "../../Interface/Separator/Separator";
import LockRow from "../../Interface/LockRow";

function Locks() {
    const locks = useSelector(store => store.staking.locks);
    const userUnlockedBalance = useSelector(store => store.staking.userUnlockedBalance);

    return (
        <Box direction="column" align="flex-start">
            Your Locks
            <Separator />
            <div style={{marginTop: 12, width: "100%", display: "flex"}}>
                <span style={{color: "var(--grey0)", width: 300}}>Date</span>
                <span style={{color: "var(--grey0)", width: 200}}>Time</span>
                <span style={{color: "var(--grey0)", flexGrow: 1}}>Amount</span>
            </div>
            <Separator margin={11} />
            { userUnlockedBalance !== "0" &&
              <LockRow lock={{amount: userUnlockedBalance, type: "Basic"}} last={locks.length === 0} />
            }
            {locks.map((lock, index) => <LockRow lock={lock} key={index} last={index === locks.length - 1} />)}
        </Box>
    );
}

export default Locks;
